module.exports = __webpack_public_path__ + "assets/4dc0cf2902017c926c3687ba7f27a699.mp3";